module.exports = __webpack_public_path__ + "static/img/IMG_20170729_220826.e8208bb9.jpg";